import { createApi } from "@reduxjs/toolkit/query/react";
import config from "./../config";
import baseQueryWithCorrelationId from "../services/baseQueryWithCorrelationId";

const sessionSlice = createApi({
    reducerPath: "sessionSlice",
    baseQuery: baseQueryWithCorrelationId(`${config.REACT_APP_SECURITY_API_URL}${config.REACT_APP_ENV_NAME}`),
    endpoints: (builder) => ({
        getSessionInfo: builder.query({
            query: () => ({
                url: `?_action=getSessionInfo&realm=external`,
                method: "POST",
                headers: {
                    "Accept-API-Version": "protocol=1.0,resource=2.0"
                }
            }),
        }),
    }),
});

export const { useGetSessionInfoQuery, useLazyGetSessionInfoQuery } = sessionSlice;

export default sessionSlice;
